import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { COMPANY } from "@/lib/site";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen royal-radial flex flex-col items-center justify-center gap-5" data-testid="protected-loading">
        <img src={COMPANY.logo} alt="crest" className="w-20 h-20 object-contain rounded-xl animate-float" />
        <span className="text-emerald-300/70 font-garamond tracking-widest">VERIFYING CREDENTIALS…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/account" replace />;
  return children;
}
